import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=1abc84c8&"
import script from "./overlay.vue?vue&type=script&lang=ts&"
export * from "./overlay.vue?vue&type=script&lang=ts&"
import style0 from "./overlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports